<template>
    <div class="layout-comment-edit-panel" v-bind:class="className">
        <div v-if="textValue && textValue != ''">
            <div v-if="!editable">
                <div class="layout-cep-text-paragraph" v-bind:class="{'layout-cep-text-paragraph-all': showAll || hideShowAll}">
                    <p v-bind:id="'editpanel' + textId" v-html="UTILS.getBreakLineByText(textValue)"></p>
                </div>
                <div class="layout-cep-edit dsp-flex">
                    <div class="layout-cep-edit-half edit-left"><span class="span-show-all" v-if="textValueLong" @click="clickShowAll">{{showAllText}}</span></div>
                    <div v-if="!hideEdit" class="layout-cep-edit-half edit-right"><span class="span-edit" @click="clickEdit">编辑</span></div>
                </div>
            </div>
            <div v-else class="layout-textare-box">
                <textarea class="layout-cep-textarea" v-bind:class="{'layout-cep-textarea-focus' : focused}" @focus="focusTextArea" @blur="blurTextArea" v-model="textStr" name="base" id="" cols="30" rows="4" placeholder="请输入" maxlength="3000"></textarea>
                <div class="layout-fake-textarea" @click="clickFakeTextArea"></div>
                <!-- <div class="layout-cep-save"><span @click="clickSave">保存</span></div> -->
            </div>
        </div>
        <div v-else class="layout-textare-box">
            <textarea class="layout-cep-textarea" v-bind:class="{'layout-cep-textarea-focus' : focused}" @focus="focusTextArea" @blur="blurTextArea" v-model="textStr" name="base" id="" cols="30" rows="4" placeholder="请输入" maxlength="3000"></textarea>
            <div class="layout-fake-textarea" @click="clickFakeTextArea"></div>
            <!-- <div class="layout-cep-save"><span v-bind:class="{'gray': textStr == ''}" @click="clickSave">保存</span></div> -->
        </div>
    </div>
</template>

<script>
import { UA, UTILS } from '../../modules/utils';
import { COMMENT_DOM, FAMOUS_DOM } from '../../modules/dom';
export default {
    name: 'CommentEditPanel',
    props: {
        fromPage: {
            type: String,
            default() { return '' }
        },
        className: {
            type: String,
            default() { return '' }
        },
        parentData: {
            type: Object,
            default() { return {} }
        },
        textValue: {
            type: String,
            default() { return '' }
        },
        textId: {
            type: String,
            default() { return '' }
        },
        editFunc: {
            type: Function,
            default() { return null }
        },
        saveFunc: {
            type: Function,
            default() { return null }
        },
        hideEdit: {
            type: Boolean,
            default() { return false }
        },
        hideShowAll: {
            type: Boolean,
            default() { return false }
        },
        autoSave: {
            type: Boolean,
            default() { return true }
        }
    },
    data() {
        return {
            UTILS: UTILS,
            editable: false,
            textStr: '',
            textHtml: '',
            textValueLong: false,
            showAll: false,
            showAllText: '显示全文',
            showFakeText: false,
            curFakeTextNode: null,
            focused: false
        }
    },
    mounted: function() {
        // 显示透明层
        this.showFakeText = UA.isIphone();

        var me = this;
        setTimeout(() => {
            me.checkTextValue();
        }, 20);
    },
    methods: {
        clickShowAll() {
            var curShowAll = this.showAll; this.showAll = !curShowAll;
            this.showAllText = this.showAll ? '收起' : '显示全文';
        },
        clickEdit() {
            this.editable = true;
            this.textStr = this.textValue;
            // 编辑状态下:重置显示全文的逻辑
            this.showAll = false;
            this.showAllText = '显示全文';
        },
        clickSave() {
            var me = this;
            var text = this.textStr;
            // 在初始化数据后保存为空的话,返回
            if(text == '' && !this.editable){
                // this.$toast('请输入内容后再保存')
                return;
            }

            // 内容没有改变不提交    
            if(text == this.textValue) {
                this.editable = false;
                this.textStr = '';
                setTimeout(() => {
                    me.checkTextValue();
                }, 0);
                return;
            }

            var parentData = this.parentData ? this.parentData : null;
            if(this.saveFunc && typeof(this.saveFunc) == 'function') {
                this.saveFunc(text, parentData, function(){
                    me.editable = false;
                    me.textStr = '';
                    setTimeout(() => {
                        me.checkTextValue();
                    }, 0);
                });
            }
        },
        checkTextValue() {
            if(this.hideShowAll) {
                this.textValueLong = false;
                return;
            }
            // 文本的显示全文状态
            var pNode = document.getElementById('editpanel' + this.textId);
            if(pNode != null){
                this.textValueLong = pNode.clientHeight > pNode.parentNode.clientHeight ? true : false;
            }
        },
        clickFakeTextArea(event) {
            var me = this, 
                curNode = event.target, 
                nextNode = curNode.nextElementSibling,
                textNode = curNode.previousElementSibling;
            this.curFakeTextNode = curNode;
            this.curFakeTextNode.style = 'display: none';
            textNode.focus();

            // 光标定位到文本末尾
            var leng = this.textStr.length;
            textNode.setSelectionRange(leng, leng);
            
            if(UA.isIphone()) {
                var parentNode = this.$el.parentNode;
                // 编辑百科
                if(this.fromPage == 'famousCreateList' || this.fromPage == 'famousCreateForm') {
                    setTimeout(() => {
                        FAMOUS_DOM.updateFamousFormTextAreaScrollTop(parentNode, true);
                    }, 300);
                }
                // 编辑批盘
                if(this.fromPage == 'commentList' || this.fromPage == 'commentForm') {
                    setTimeout(() => {
                        COMMENT_DOM.updateCommentTextAreaScrollTop(parentNode, true);
                    }, 300);
                }
            }
        },
        focusTextArea() {
            this.focused = true;
            
            if(this.fromPage == 'famousCreateList' || this.fromPage == 'famousCreateForm') {
                return;
            }

            // 隐藏迷你命盘的第三行数据
            var showLines = this.$store.state.minifatefortune.showLines;
            if(showLines == 2){
                this.$store.state.minifatefortune.showLines = 1;
                COMMENT_DOM.updateCommentFormStyle();
            }

            var parentNode = this.$el.parentNode;
            var originalHeight = document.documentElement.clientHeight || document.body.clientHeight;
            // console.log('focusTextArea------', parentNode, parentNode.className, showLines)
            if(UA.isIphone()) {
                this.$store.state.comment.showBottomBar = false;
                // 设置顶部菜单的样式
                var topbarDiv = document.getElementsByClassName('comment-fate-topbar')[0];
                if(topbarDiv) {
                    topbarDiv.style = 'position: absolute; left: 0; top: 0';
                }
            }else if(UA.isAndroid()) {
                this.$store.state.comment.showBottomBar = false;
                
                // 安卓滚动到当前输入框的位置:弹出软键盘之后再滚动
                var me = this;
                window.onresize = function() {
                    setTimeout(() => {
                        var resizeHeight = document.documentElement.clientHeight || document.body.clientHeight;
                        // console.log('resiiiiiiiize----focus', originalHeight, resizeHeight)
                        if(parseInt(originalHeight) > parseInt(resizeHeight)) {
                            me.$store.state.comment.showBottomBar = false;
                        }else{
                            me.$store.state.comment.showBottomBar = true;
                        }
                    }, 10);
                    setTimeout(() => {
                        COMMENT_DOM.updateCommentTextAreaScrollTop(parentNode, false);
                    }, 300);
                }
            }
        },
        blurTextArea() {
            this.focused = false;
            var parentNode = this.$el.parentNode;
            if(UA.isIphone()) {
                if(this.curFakeTextNode != null) {
                    this.curFakeTextNode.style = '';
                }
                this.$store.state.comment.showBottomBar = true;
                if(this.fromPage == 'famousCreateList' || this.fromPage == 'famousCreateForm') {
                    FAMOUS_DOM.updateFamousFormStyle();
                    setTimeout(() => {
                        FAMOUS_DOM.updateFamousFormTextAreaScrollTop(parentNode, false);
                    }, 100);
                }
                if(this.fromPage == 'commentList' || this.fromPage == 'commentForm') {
                    // 设置顶部菜单的样式:::兼容IOS嵌入页
                    var topbarDiv = document.getElementsByClassName('comment-fate-topbar')[0];
                    if(topbarDiv) { topbarDiv.style = ''; }
                    COMMENT_DOM.updateCommentFormStyle();
                    setTimeout(() => {
                        COMMENT_DOM.updateCommentTextAreaScrollTop(parentNode, false);
                    }, 100);
                }
            }else if(UA.isAndroid()) {
                this.$store.state.comment.showBottomBar = true;
            }
            if(this.autoSave) {
                this.clickSave();
            }
        }
    }
}
</script>